<template>
  <div>
    <v-row>
      <v-tabs v-model="tab">
        <v-tab>
          Tabela
        </v-tab>
        <v-tab>Wykres</v-tab>
      <v-tab-item>
        <v-data-table :loading="!isInit" :headers="tableHeader" :items="tableData"></v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-col cols="12" lg="3">
          <v-select v-model="itemsCount" :items="selectItems" label="Ilość wyświetlanych wdrożeń na wykresie"></v-select>
        </v-col>
        <bar-chart v-if="filteredChartData" :chartData="filteredChartData"
                   :height="800"
                   :options="{maintainAspectRatio:false, scales:{yAxes:[{ticks:{beginAtZero:true}}]}}"></bar-chart>
      </v-tab-item>
      </v-tabs>
    </v-row>
    <v-row>

    </v-row>

  </div>
</template>

<script>
import {barChart} from "@/components/charts";
import {getNextColorForChart, resetColorForChart} from "@/helpers";

export default {
  components: {
    barChart
  },
  computed: {
    filteredChartData() {
      if (this.chartData) {
        var datasets = []
        if (this.itemsCount > 0) {
          datasets = this.chartData.datasets.slice(0, this.itemsCount)
        } else {
          datasets = this.chartData.datasets;
        }
        return {
          labels: this.chartData.labels,
          datasets: datasets
        }
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      isInit: false,
      tab: null,
      selectItems: [
        {text: '10', value: 10},
        {text: '20', value: 20},
        {text: '50', value: 50},
        {text: 'Wszystkie', value: 0}
      ],
      itemsCount: 10,
      chartData: null,
      tableData: [],
      tableHeader:[
        {
          text:'Nazwa wdrożenia',
          value:'companyName',
          width:'30%'
        },
        {
          text: 'Wszystkie sloty',
          value:'totalSlots'
        },
        {
          text: 'Potwierdzone sloty',
          value: 'confirmSlots'
        },
        {
          text: 'Wolne sloty',
          value: 'freeSlots'
        }
      ]
    }
  },
  mounted() {
    var vm = this;
    resetColorForChart("todayReservation");
    vm.$http.get("Report/TodayReservation").then(response => {
      vm.chartData = {
        labels: response.data.labels,
        datasets: response.data.datasets
      }
      vm.tableData = response.data.listData;
      vm.isInit = true;
      vm.chartData.datasets.forEach(el=>el.backgroundColor = getNextColorForChart("todayReservation"))
    });
  }
};
</script>
